import { createGqlClient } from "@insightfulscience/shared-utils/gqlClient";
import { batch, recovery, tap } from "@insightfulscience/shared-utils/gqlClient/middlewares";

const gqlClient = ({
	recoveryService: { shouldBeRecovered, recover },
	publicConfig: { GRAPHQL_URI, GRAPHQL_INTERNAL_URI },
	gqlEventsListener,
}) =>
	createGqlClient(
		{ uri: typeof window === "undefined" ? GRAPHQL_INTERNAL_URI : GRAPHQL_URI },
		tap(gqlEventsListener),
		recovery(shouldBeRecovered, recover()),
		batch(),
	);

export default gqlClient;
